import * as types from "../../Action/actionTypes"

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const selectRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_ROLE_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case types.SELECT_ROLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case types.SELECT_ROLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default selectRoleReducer
